import { gql } from 'graphql-request'
import { useMutation } from '@hooks/graphql'

import { useNavigate } from 'react-router-dom'
import { MoreHorizontal } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'

const REMOVE_COLLABORATORS_FROM_CLASSROOM = gql`
  mutation removeCollaboratorsFromClassroom($input: RemoveCollaboratorsFromClassroomInput!) {
    removeCollaboratorsFromClassroom(input: $input) {
      success
      errors {
        message
      }
    }
  }
`

const COLLABORATOR_LEAVE_CLASSROOM = gql`
  mutation collaboratorLeaveClassroom($input: LeaveClassroomInput!) {
    collaboratorLeaveClassroom(input: $input) {
      success
      errors {
        message
      }
    }
  }
`

const CollaboratorsListActions = ({ id, classroomId, currentUserIsOwner, isOwner, currentUserIsCollaborator, refetchCollaborators }) => {
  const navigate = useNavigate()

  const { mutate: removeCollaboratorsFromClassroom } = useMutation({
    gqlMutation: REMOVE_COLLABORATORS_FROM_CLASSROOM,
    onSuccess: () => {
      refetchCollaborators()
    }
  })

  const { mutate: collaboratorLeaveClassroom } = useMutation({
    gqlMutation: COLLABORATOR_LEAVE_CLASSROOM,
    onSuccess: () => {
      navigate('/educators/classrooms')
    }
  })

  const removeCollaborator = (id) => {
    removeCollaboratorsFromClassroom({
      input: {
        classroomId,
        collaboratorIds: [id]
      }
    })
  }

  const leaveClassroom = (id) => {
    collaboratorLeaveClassroom({
      input: {
        classroomId,
        educatorId: id
      }
    })
  }

  return (
    <div className='h-[32px]'>
      <Choose>
        <When condition={currentUserIsOwner && !isOwner}>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant='ghost' size='sm'>
                <span className='sr-only'>Open menu</span>
                <MoreHorizontal />
              </Button>
            </DropdownMenuTrigger>

            <DropdownMenuContent align='end'>
              <DropdownMenuItem onClick={() => removeCollaborator(id)}>
                Remove
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </When>

        <When condition={currentUserIsCollaborator && !isOwner}>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant='ghost' size='sm'>
                <span className='sr-only'>Open menu</span>
                <MoreHorizontal />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align='end'>
              <DropdownMenuItem onClick={() => leaveClassroom(id)}>
                Leave classroom
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </When>
      </Choose>
    </div>
  )
}

export default CollaboratorsListActions
